import { Observable } from 'rxjs';
import { CreateImpersonationAuthTokenRequest, PhoneNumber, SingleUserResponse, User, UserApi } from 'src/app/hickory-api';
import { MockUserMode } from 'src/utility/mock-mode';
import { mockHandler, mockUserMode } from '../mock.handler';
import { getSingle } from './data/SingleHelper';

export class MockUserApi extends UserApi {

  private defaultUser: User = {
    agency: 'agency',
    id: 123,
    tenantId: -1,
    name: {
      familyName: 'Last',
      givenName: 'First'
    },
    permissions: [],
    identity: {
      id: 123,
      username: 'username',
      isAuthenticated: true
    },
    features: [],
    featureSet: null,
    bundle: null,
    chatApplicationId: 'AppId',
    contact: {
      emails: [
        { address: 'test@email.com' }
      ],
      firstName: 'First',
      id: 123,
      lastName: 'Last',
      phones: [
        this.getActualPhoneNumber('208-123-4567')
      ],
      chatUser: {
        id: 'string',
        displayName: 'string',
        firstName: 'string',
        lastName: 'string',
        phoneNumber: 'string',
        emailAddress: 'string',
        publicKey: 'string',
        avatarUrl: 'string',
        metadata: 'string',
      }
    }
  };
  private minimalUser: User = {
    id: 456,
    tenantId: -1,
    name: {
      givenName: null,
      familyName: null
    },
    agency: null,
    bundle: null,
    permissions: [],
    chatApplicationId: 'AppId',
    contact: null
  };
  private fullUser: User = {
    agency: 'agency',
    id: 123,
    tenantId: -1,
    name: {
      familyName: 'Last',
      givenName: 'First'
    },
    permissions: ['roles.manage', 'cms.bcp', 'hickory.IncidentManagement'],
    identity: {
      id: 123,
      username: 'username',
      isAuthenticated: true
    },
    features: [],
    featureSet: null,
    bundle: {
      android: {
        uri: 'http://localhost:4200/resources/test/sephora_test_bundle.zip'
      }
    },
    bcp: {
      android: {
        uri: 'http://localhost:4200/resources/test/cms-bcp.zip'
      }
    },
    chatApplicationId: 'AppId',
    contact: {
      emails: [
        { address: 'test@email.com' }
      ],
      firstName: 'First',
      id: 123,
      lastName: 'Last',
      phones: [
        this.getActualPhoneNumber('208-123-4567')
      ],
      chatUser: {
        id: 'string',
        displayName: 'string',
        firstName: 'string',
        lastName: 'string',
        phoneNumber: 'string',
        emailAddress: 'string',
        publicKey: 'string',
        avatarUrl: 'string',
        metadata: 'string',
      }
    }
  };
  private alternateUser: User = {
    id: 789,
    name: {
      givenName: null,
      familyName: null
    },
    agency: 'Sephora',
    bundle: null,
    permissions: [],
    chatApplicationId: 'AppId',
    contact: null
  };
  private edgeCaseUser: User = {};

  getActualPhoneNumber(num: string): PhoneNumber {
    const phone: any = {
      number: undefined, // What you think you get
      Number: num // How it's actually returned from the service
    }
    return phone;
  }

  currentUser() {
    switch (mockUserMode()) {
      case MockUserMode.Minimal:
        return this.minimalUser;
      case MockUserMode.Full:
        return this.fullUser;
      case MockUserMode.Alternate:
        return this.alternateUser;
      case MockUserMode.EdgeCase:
        return this.edgeCaseUser;
      case MockUserMode.Default:
      default:
        return this.defaultUser;
    }
  }

  createImpersonationAuthToken(body: CreateImpersonationAuthTokenRequest): Observable<any> {
    return mockHandler({
      item: {
        token: 'impersonation'
      },
      hasErrors: false,
      isValid: true
    });
  }

  getUser(): Observable<any> {
    const response: SingleUserResponse = getSingle(this.currentUser());
    return mockHandler(response);
  }
}
